export const InvalidFieldClassName = "scds-input-is-invalid";
